import { render } from "./FilterSidebarInClosedItems.vue?vue&type=template&id=efd3ce1c&scoped=true"
import script from "./FilterSidebarInClosedItems.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInClosedItems.vue?vue&type=script&lang=js"

import "./FilterSidebarInClosedItems.vue?vue&type=style&index=0&id=efd3ce1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd3ce1c"]])

export default __exports__